<template>
  <div id="home" class="n3-inicio" ref="raiz">
    <!-- Mismo orden y mismos interruptores que la portada de siempre (panel: Inicio) -->
    <N3Portada />
    <N3Notario />
    <N3Servicios />
    <N3Blog />
    <N3Llamada />
    <N3Testimonios />
    <N3Galeria />
    <N2Faq />
    <N2Contacto con-titulo />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAparicion } from '../../composables/useNotaria2'
import N3Portada from './N3Portada.vue'
import N3Notario from './N3Notario.vue'
import N3Servicios from './N3Servicios.vue'
import N3Blog from './N3Blog.vue'
import N3Llamada from './N3Llamada.vue'
import N3Testimonios from './N3Testimonios.vue'
import N3Galeria from './N3Galeria.vue'
import N2Faq from '../notaria2/N2Faq.vue'
import N2Contacto from '../notaria2/N2Contacto.vue'

const raiz = ref(null)
useAparicion(raiz)
</script>
